import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import scheduler from './services/scheduler/reducer';
import calendarCreationData from './services/create_calendar/reducer';
import scheduleCreationData from './services/create_schedule/reducer';
import slotPickupData from './services/pickup_slot/reducer';
import redirect from './services/redirect/reducer';
import loader from './services/loader/reducer';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

const initialAppState = {};

const middleware = [thunk, logger];

const store = createStore(
  combineReducers({
    scheduler,
    calendarCreationData,
    scheduleCreationData,
    slotPickupData,
    loader,
    redirect
  }),
  initialAppState,
  applyMiddleware(...middleware)
);

export default store;